// extracted by mini-css-extract-plugin
export default {"icon":"ToTopArrow_icon_a06c8","button":"ToTopArrow_button_b24e0"};